import { createFileRoute } from '@tanstack/react-router';

import { CreativeEditorPage } from '../features/campaigns/creatives/components/CreativeEditor/CreativeEditorPage';
import { creativesRouteSearchSchema } from '../features/campaigns/creatives/creativesRouteSearch';
import { CreativeEditorMode, CreativeTab } from '../features/campaigns/creatives/model';

export const Route = createFileRoute('/campaigns/creatives_/display_/edit/$creativeId')({
  validateSearch: creativesRouteSearchSchema,
  component: DisplayCreativeEditRoute,
});

function DisplayCreativeEditRoute() {
  const { creativeId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <CreativeEditorPage
      tab={CreativeTab.Display}
      mode={CreativeEditorMode.Edit}
      brandId={search.brand ?? ''}
      creativeId={creativeId}
    />
  );
}
